<template>
  <v-card class="MessageCard">
    <v-toolbar v-if="inDialog"
               color="primary"
               dark
               flat
               tile>
      <v-toolbar-title>
        Email #{{ message.id }}
        <v-btn icon
               class="ml-1"
               x-small
               :to="{name: 'admin.mailgun_message.show', params: {messageID: message.id}}"
               target="_blank">
          <v-icon>
            fas fa-fw fa-external-link-alt
          </v-icon>
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn light
             @click.prevent="closeDialog">
        Close
      </v-btn>
    </v-toolbar>
    <v-card-text class="pb-0"
                 :class="inDialog ? 'pt-6' : ''">
      <v-text-field :value="fromAddress"
                    label="From:"
                    filled
                    disabled
                    dense>
      </v-text-field>
      <v-text-field :value="message.recipient"
                    label="To:"
                    filled
                    disabled
                    dense>
      </v-text-field>
      <v-text-field :value="message.subject"
                    label="Subject:"
                    filled
                    disabled
                    dense>
      </v-text-field>

      <v-text-field v-if="message.template"
                    :value="message.template.name"
                    label="Template:"
                    filled
                    disabled
                    dense>
      </v-text-field>
      <v-row>
        <v-col cols="12"
               sm="4">

          <MessageDateInfo label="Created"
                           :date="message.created_at">
          </MessageDateInfo>

          <MessageDateInfo label="Delivered"
                           :date="message.delivered_at">
          </MessageDateInfo>

        </v-col>

        <v-col cols="12"
               sm="4">

          <MessageDateInfo label="Opened"
                           :date="message.opened_at">
          </MessageDateInfo>

          <MessageDateInfo label="Clicked"
                           :date="message.clicked_at">
          </MessageDateInfo>

        </v-col>

        <v-col cols="12"
               sm="4">

          <MessageDateInfo label="Failed"
                           :date="message.failed_at">
          </MessageDateInfo>

          <MessageDateInfo label="Complained"
                           :date="message.complained_at">
          </MessageDateInfo>

        </v-col>

      </v-row>
    </v-card-text>
    <template>
      <v-tabs v-model="tab">
        <v-tab>
          Message Content
        </v-tab>
        <v-tab>
          Message History
        </v-tab>
      </v-tabs>

      <v-divider></v-divider>

      <v-tabs-items v-model="tab">

        <v-tab-item :value="0">
          <div v-if="loading"
               class="d-flex justify-center">
            <v-progress-linear indeterminate
                               color="primary"
                               height="30"
                               dark>
              <template v-slot:default>
                Retrieving message
              </template>
            </v-progress-linear>
          </div>
          <div v-else-if="previewImageURI || dataURI">
            <v-alert type="info"
                     tile
                     class="mb-0">
              You can't click the links in the email.
            </v-alert>
            <v-card-text style="position: relative; min-height: 400px; overflow-y: auto;">
              <div v-if="previewImageURI"
                   class="d-flex justify-center">
                <v-img :src="previewImageURI"
                       :max-width="previewImageWidth"
                       alt="Preview"/>
              </div>
              <div v-else-if="dataURI"
                   style="width: 100%; height: 100%; position: relative;">
                <iframe :src="dataURI"
                        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"
                        @load="resizeIFrame($event)">
                </iframe>
              </div>
            </v-card-text>
          </div>
          <v-alert v-else
                   type="info"
                   flat
                   tile
                   class="mb-0">
            We couldn't find the content for this message.
          </v-alert>

        </v-tab-item>

        <v-tab-item :value="1">
          <v-card-text v-if="webhooksLoading">
            <div class="d-flex justify-center">
              <v-progress-circular indeterminate>
              </v-progress-circular>
              Retrieving message history
            </div>
          </v-card-text>
          <v-simple-table v-else
                          dense
                          class="MailgunWebhookTable mb-8">
            <thead>
            <tr>
              <th class="Email__Metadata_Label">
                Date
              </th>
              <th>
                Status
              </th>
              <th>
                Details
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="webhook in filteredWebhooks"
                :key="webhook.id">
              <td class="Email__Metadata_Label">
                {{ webhook.event_at | datetime }}
              </td>
              <td>
                <MailgunWebhookEvent v-if="message.is_mailgun"
                                     :webhook="webhook">
                </MailgunWebhookEvent>
                <NylasWebhookEvent v-else-if="message.is_nylas"
                                   :webhook="webhook">
                </NylasWebhookEvent>
              </td>
              <td>
                <MailgunWebhookMessage v-if="message.is_mailgun"
                                       :message="message"
                                       :webhook="webhook">
                </MailgunWebhookMessage>
                <NylasWebhookMessage v-else-if="message.is_nylas"
                                     :message="message"
                                     :webhook="webhook">
                </NylasWebhookMessage>
              </td>
            </tr>
            <tr>
              <td class="Email__Metadata_Label">
                {{ message.created_at | datetime }}
              </td>
              <td>
                <v-chip label
                        small
                        color="blue lighten-3"
                        dark
                        class="text-center font-weight-bold d-block">
                  <v-icon left
                          x-small>
                    fas fa-fw fa-hourglass-start
                  </v-icon>
                  Created
                </v-chip>
              </td>
              <td>
                {{ message.sender ? message.sender.name : 'Mobile Locker' }} created the message.
              </td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-tab-item>
      </v-tabs-items>

      <v-divider></v-divider>

    </template>
  </v-card>
</template>
<style lang="scss"
       scoped>
.MessageCard .IFrameOverlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 22px;
  //width: 100%;
  height: 100%;
  border: 0;
  z-index: 99999;
}

.MailgunWebhookTable table {
  th:nth-child(1), td:nth-child(1),
  th:nth-child(2), td:nth-child(2) {
    width: 180px;
  }

  th:nth-child(3), td:nth-child(3) {
    width: auto;
  }
}
</style>
<script>

import MessageDateInfo from './MessageDateInfo.vue';
import mailgunService from '../../../../../../ml/services/mailgunService';
import {isObject, isString, orderBy} from 'lodash';
import MailgunWebhookEvent from '../../../mailgun/components/MailgunWebhookEvent.vue';
import MailgunWebhookMessage from '../../../mailgun/components/MailgunWebhookMessage.vue';
import htmlService from '../../../../services/htmlService';
import browserlessService from '../../../../services/browserlessService';
import nylasService from '../../../../services/nylasService';
import NylasWebhookEvent from '../../../nylas/components/NylasWebhookEvent.vue';
import NylasWebhookMessage from '../../../nylas/components/NylasWebhookMessage.vue';

export default {
  components: {NylasWebhookMessage, NylasWebhookEvent, MailgunWebhookMessage, MailgunWebhookEvent, MessageDateInfo},
  props: {
    busy: {
      type: Boolean,
      required: true,
    },
    inDialog: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Object,
      required: true,
    },
    raw: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      messageCardHeight: null,
      tab: 0, // MLD-6816
      webhooks: [],
      webhooksLoading: false,
      imageLoading: false,
      previewImage: null, // MLD-7940
      previewImageWidth: 600,
    }
  },
  computed: {
    loading() {
      return this.webhooksLoading
        || this.imageLoading;
    },
    previewImageURI() { // MLD-7932
      if (isObject(this.previewImage) && isString(this.previewImage.image)) {
        return `data:image/png;base64,${this.previewImage.image}`;
      }
      return null;
    },
    dataURI() {
      if (this.message && this.raw && this.raw.body) {
        const html = htmlService.addOverlayToHTML(this.raw.body); // MLD-7817
        return htmlService.dataURI(html);
      }
      return null;
    },
    fromAddress() {
      if (this.message.sender?.name) {
        return `${this.message.sender?.name} <${this.message.from_email}>`;
      }
      return this.message.from_address;
    },
    messageID() {
      return parseInt(this.$route.params.messageID);
    },
    messageCardStyle() {
      if (this.messageCardHeight) {
        return `height: ${this.messageCardHeight}px`;
      }
      return null;
    },
    filteredWebhooks() { // MLD-6816
      if (this.message.is_nylas) {
        return this.webhooks.filter(e => e.is_type_update === false);
      }
      return this.webhooks.filter(w => w.is_bot === false);
    }
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() { // MLD-6816
      await this.getWebhooks();
      await this.generateImage(); // MLD-7940
    },
    async generateImage() { // MLD-7940
      if (this.raw && this.raw.body) {
        try {
          this.imageLoading = true;
          this.previewImage = await browserlessService.screenshotEmail(this.raw.body, this.previewImageWidth);
        } catch (error) {
          this.previewImage = null;
        } finally {
          this.imageLoading = false;
        }
      }
    },
    async getWebhooks() { // MLD-6816
      this.webhooksLoading = true;

      try {
        if (this.message.is_mailgun) {
          await this.getMailgunWebhooks()
        } else if (this.message.is_nylas) {
          await this.getNylasEvents();
        }
      } catch (e) {
      } finally {
        this.webhooksLoading = false;
      }
    },
    async getMailgunWebhooks() {
      const form = {
        //message_id: this.message.message_id, // MLD-4540
        mailgun_message_id: this.message.id,
        page: 1,
        per_page: 100,
        include_shared_link: true, // MLD-7813
      }
      const data = await mailgunService.getWebhooks(form)
      this.webhooks = orderBy(data.data, ['event_timestamp', 'event_at'], ['desc', 'desc']);
    },
    async getNylasEvents() {
      const form = {
        mailgun_message_id: this.message.id,
        page: 1,
        per_page: 100,
        include_shared_link: true,
      }
      const data = await nylasService.getEvents(form);
      this.webhooks = orderBy(data, ['event_timestamp', 'event_at'], ['desc', 'desc']);
    },
    resizeIFrame(event) {
      try {
        const iframe = event.target;
        const document = iframe.contentDocument || iframe.contentWindow.document;
        const height = document.documentElement.scrollHeight || document.body.scrollHeight;
        iframe.style.height = height + 'px';
      } catch (e) {
        console.log('Error resizing iframe: ', e);
      }
    },
    closeDialog() {
      this.$emit('closed');
    }
  },
}
</script>
